// extracted by mini-css-extract-plugin
export default {"errorBoundary":"ErrorBoundary-module__errorBoundary"};